/*eslint-disable*/
import React from "react";
import classNames from "classnames";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import InshaHeader from "./InshaHeader";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import InshaFooter from "./InshaFooter";
import InshaHeaderLink from "./InshaHeaderLink";
// import SectionDescription from "views/AboutUsPage/Sections/SectionDescription.js";
import ShippingDescription from "views/InshaBanglesPage/Section/ShippingDescription";
// import SectionTeam from "views/AboutUsPage/Sections/SectionTeam.js";
// import SectionOffice from "views/AboutUsPage/Sections/SectionOffice.js";

import aboutUsStyle from "assets/jss/material-kit-pro-react/views/aboutUsStyle.js";
import aboutUsStyl from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(aboutUsStyle);
const useStyle = makeStyles(aboutUsStyl);

export default function Shipping() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const classe = useStyle();

  const currentUrl = "https://inshabangles.com/shipping";
  const seoTitle = "Shipping Policy | INSHA BANGLES";
  const seoDescription =
    "Read the Shipping Policy of INSHA BANGLES to understand delivery timelines, shipping process, dispatch details, and support for order delivery.";
  const seoKeywords =
    "INSHA BANGLES shipping policy, jewellery shipping policy, bangles delivery policy, imitation jewellery shipping, order dispatch policy";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const shippingSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Shipping Policy",
    url: currentUrl,
    description: seoDescription,
    publisher: {
      "@type": "Organization",
      name: "INSHA BANGLES",
      logo: {
        "@type": "ImageObject",
        url: ogImage,
      },
    },
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="INSHA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(shippingSchema)}
        </script>
      </Helmet>
      <InshaHeader
        brand="Home"
        links={<InshaHeaderLink dropdownHoverColor="dark" />}
        fixed
        color="dark"
        // color="transparent"
        // changeColorOnScroll={{
        //   height: 300,
        //   color: "dark",
        // }}
      />
      <Parallax
        image={require("assets/img/Shipping.jpg").default}
        // filter="dark"
        small
        style={
          window.innerWidth <= 600
            ? {
                height: "260px",
                minHeight: "260px",
                backgroundSize: "cover",
                backgroundPosition: "center center",
              }
            : {}
        }
      >
        <div className={classe.container}>
          <GridContainer justify="center">
            <GridItem
              md={10}
              sm={10}
              className={classNames(
                classe.mlAuto,
                classe.mrAuto,
                classe.textCenter,
              )}
            >
              <h1
                style={{
                  color: "#000",
                  fontFamily: "Tahoma",
                  fontWeight: "bold",
                }}
              >
                Shipping
              </h1>
              <h4 style={{ color: "#000" }}>
                Your satisfaction important to us...
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <ShippingDescription />
          {/* <SectionTeam /> */}
          {/* <SectionOffice /> */}
          <br />
        </div>
      </div>
      <br />
      <br />
      <InshaFooter />
    </div>
  );
}
